import { FC } from "react";
import { Form } from "antd";
import cn from "classnames";
import { PASSENGER_CLASSES } from "../../../constants";
import { DefaultCheckIcon } from "src/assets/Icons";

type ClassOptionsProps = {
  value?: number;
  onChange?: (value: number) => void;
};

const ClassOptions: FC<ClassOptionsProps> = ({ value, onChange }) => {
  return (
    <div className="flex flex-col gap-2">
      {PASSENGER_CLASSES.map((passengerClass) => {
        const isSelected = passengerClass.key === value;
        return (
          <div
            key={passengerClass.key}
            className={cn(
              "flex w-full text-font-default cursor-pointer items-center justify-between rounded-sm p-3 ps-5 font-semibold transition-all duration-300 hover:bg-background-primary-lighter ",
              isSelected && "text-font-active!",
            )}
            onClick={() => onChange?.(passengerClass.key)}
          >
            {passengerClass.label}
            {isSelected && <DefaultCheckIcon className="h-4 w-4" />}
          </div>
        );
      })}
    </div>
  );
};

export default function ClassSelectContent() {
  return (
    <Form.Item name="flightCabinClass" className="m-0!">
      <ClassOptions />
    </Form.Item>
  );
}
